/**
 * WP-V2-TW — katalog obiektów interaktywnych Town (PLAN-V2 §6).
 * Placeholdery: brak PNG → silnik rysuje kolorowy kształt + ikonę.
 * Hit-area ≥64 px (MIN_OBJECT_SIZE w interact/).
 */
import type { ObjectDef, SpawnPlacement } from '../../interact/types.js';

/** Definicje typów obiektów ulicznych. */
export const TOWN_OBJECT_DEFS: readonly ObjectDef[] = [
  {
    id: 'town_ball',
    texture: 'obj_town_ball',
    size: 64,
    interactions: ['bounce', 'tap', 'drag'],
    fx: 'sparkle',
    dogReaction: 'happy',
  },
  {
    id: 'town_puddle',
    texture: 'obj_town_puddle',
    size: 72,
    interactions: ['tap'],
    fx: 'splash',
    dogReaction: 'jump',
  },
  {
    id: 'town_bench',
    texture: 'obj_town_bench',
    size: 96,
    interactions: ['tap'],
    fx: 'sparkle',
    dogReaction: 'happy', // sit via listener w scenie
  },
  {
    id: 'town_lamp',
    texture: 'obj_town_lamp',
    size: 64,
    interactions: ['toggle', 'tap'],
    states: ['off', 'on'],
    fx: 'sparkle',
  },
  {
    id: 'town_bird',
    texture: 'obj_town_bird',
    size: 64,
    interactions: ['tap'],
    fx: 'sparkle',
    dogReaction: 'sniff',
  },
  {
    id: 'town_flowerbox',
    texture: 'obj_town_flowerbox',
    size: 72,
    interactions: ['tap'],
    fx: 'stars',
    dogReaction: 'happy',
  },
  {
    id: 'town_fountain',
    texture: 'obj_town_fountain',
    size: 110,
    interactions: ['tap'],
    fx: 'splash',
    dogReaction: 'jump',
  },
  {
    id: 'town_street_cat',
    texture: 'obj_town_cat',
    size: 64,
    interactions: ['tap'],
    fx: 'hearts',
    dogReaction: 'happy',
  },
] as const;

/**
 * Rozmieszczenie instancji po 3 dzielnicach.
 * Id def musi być w TOWN_OBJECT_DEFS.
 */
/**
 * Propsy w TOWN_WALK_BAND (minY 455): lampy przy ścieżce, ptak nisko na krzaku.
 */
export const TOWN_OBJECT_PLACEMENTS: readonly SpawnPlacement[] = [
  // —— Osiedle (0–1067) ——
  { defId: 'town_ball', x: 520, y: 560 },
  { defId: 'town_puddle', x: 300, y: 540 },
  { defId: 'town_bench', x: 700, y: 520 },
  { defId: 'town_lamp', x: 180, y: 460 },
  { defId: 'town_flowerbox', x: 750, y: 500 },
  { defId: 'town_bird', x: 650, y: 480 },
  { defId: 'town_flowerbox', x: 120, y: 500 },
  { defId: 'town_lamp', x: 480, y: 460 },

  // —— Rynek (1067–2133) ——
  { defId: 'town_fountain', x: 1600, y: 480 },
  { defId: 'town_bench', x: 1420, y: 540 },
  { defId: 'town_bench', x: 1780, y: 540 },
  { defId: 'town_lamp', x: 1250, y: 465 },
  { defId: 'town_lamp', x: 1950, y: 465 },
  { defId: 'town_flowerbox', x: 1500, y: 500 },
  { defId: 'town_flowerbox', x: 1700, y: 500 },
  { defId: 'town_ball', x: 1660, y: 560 },
  { defId: 'town_puddle', x: 1380, y: 560 },
  { defId: 'town_bird', x: 1560, y: 470 },

  // —— Pole (2133–3200) ——
  { defId: 'town_ball', x: 2500, y: 560 },
  { defId: 'town_puddle', x: 2330, y: 540 },
  { defId: 'town_bench', x: 2830, y: 540 },
  { defId: 'town_lamp', x: 2250, y: 465 },
  { defId: 'town_flowerbox', x: 2750, y: 500 },
  { defId: 'town_bird', x: 2620, y: 480 },
  { defId: 'town_bench', x: 2570, y: 520 },
  { defId: 'town_flowerbox', x: 3050, y: 500 },
  // town_street_cat: StreetCats.ts — bez duplikatu w ObjectLayer.
] as const;

/** Lista brakujących assetów PNG (DoD / worker_done). */
export const TOWN_MISSING_ASSETS: readonly string[] = [
  'bg_town_wide (3 segmenty outpaint: osiedle / rynek / pole)',
  'obj_town_ball',
  'obj_town_puddle',
  'obj_town_bench',
  'obj_town_lamp (+ on/off)',
  'obj_town_bird',
  'obj_town_flowerbox',
  'obj_town_fountain',
  'obj_town_cat / cat_street_idle|walkA|walkB',
  'dragon_day.png',
  'dragon_night.png',
  'bandana_blue (tekstura itemu Loli — katalog jest, PNG opcjonalny)',
] as const;
